import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const LinkIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 18C10 19.105 9.105 20 8 20C6.895 20 6 19.105 6 18C6 16.895 6.895 16 8 16C9.105 16 10 16.895 10 18ZM10 18H19C20.657 18 22 16.657 22 15C22 13.343 20.657 12 19 12H9C7.343 12 6 10.657 6 9C6 7.343 7.343 6 9 6H18M18 6C18 4.895 18.895 4 20 4C21.105 4 22 4.895 22 6C22 7.105 21.105 8 20 8C18.895 8 18 7.105 18 6Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

LinkIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(LinkIcon);
